import { ReactNode, useContext } from "react";
import cn from "classnames";

import { Body as CommonBody, BodyProps as CommonBodyProps } from "capitalrx-components-2.0/lib/typography";
import { ThemeSelectorContext } from "@/basic/context";

import styles from "./styles.module.scss";

export interface BodyProps extends CommonBodyProps {
  children: ReactNode;
}

export const Body = (props: BodyProps) => {
  const { children, className } = props;
  const { client } = useContext(ThemeSelectorContext);

  const bodyClass = cn(
    className,
    { [styles["Body"]]: !!client },
  );

  return (
    <CommonBody {...props} className={bodyClass}>
      {children}
    </CommonBody>
  );
};
